import { createApi } from '@reduxjs/toolkit/query/react';
import { PublishingDataDto, CreatePublishingDataDto } from '@sr/dto';
import { createBaseQuery } from 'shared/api/rtk-query';

const PUBLISHING_DATA_BASE_PATH = '/publishing-data';

export const publishingDataApi = createApi({
  reducerPath: 'publishing-data',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getPublishingData: builder.query<PublishingDataDto, number>({
      query: (id: number) => ({
        url: `${PUBLISHING_DATA_BASE_PATH}/${id}`,
        method: 'GET'
      }),
      providesTags: ['*']
    }),
    addPublishingData: builder.mutation<PublishingDataDto, { urlSuffix: string; data: CreatePublishingDataDto }>({
      query: ({ urlSuffix, data }: { urlSuffix: string; data: CreatePublishingDataDto }) => ({
        url: `${PUBLISHING_DATA_BASE_PATH}/${urlSuffix}`,
        body: data,
        method: 'POST'
      }),
      invalidatesTags: ['*']
    }),
    updatePublishingData: builder.mutation<PublishingDataDto, PublishingDataDto>({
      query: (publishingData: PublishingDataDto) => ({
        url: `${PUBLISHING_DATA_BASE_PATH}/${publishingData.id}`,
        body: publishingData,
        formData: true,
        method: 'PUT'
      }),
      invalidatesTags: ['*']
    })
  }),
  tagTypes: ['*']
});
